import IMA from './ima/imaHandler';
import PauseTeads from './teads/pauseTeadsHandler';
import PlayTeads from './teads/playTeadsHandler';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useAppSelector } from '@shared/store/hooks';

export default function AdsSelector() {
  const { pauseAd, playAd, videoAd } = useAppSelector(adsSelector);
  return (
    <>
      {videoAd ? <IMA /> : null}
      {pauseAd ? <PauseTeads /> : null}
      {playAd?.active && !pauseAd ? <PlayTeads /> : null}
    </>
  );
}
